import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import { arrowBackOutline, cardOutline, chevronForward } from 'ionicons/icons';
import React, { useState } from 'react';
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux';
import Ripples from 'react-ripples';
import { Button, Col, Container, Input, Row } from 'reactstrap';
import CartBillings from '../../components/MenuCards/cart-billing';
import CartItems from '../../components/MenuCards/cart-items';
import axios from '../../helpers/axiosInterceptor';

import actions from '../../actions/cart'
import { Link } from 'react-router-dom';
import GeneralSkeletonText from '../../components/skeleton_text/general_establishment';

const Cart: React.FC = (props: any) => {

	const [data, setData] = useState({
		details: {},
		charges: {},
		address: ''
	} as any);
	const [load, setLoad] = useState(false);
	const [coupon, setCoupon] = useState({
		code: '',
		request: false,
		returnData: false
	});

	//Selectors
	const getProductState = store => store.cart.products

	// Get index
	const getAllProducts = (store) => {
		const products = getProductState(store) ?? []
		let total = 0
		products.map((product) => {
			let addons_cost = 0
			product.addons_product.map(d =>
				d.addons.map(d => addons_cost += parseInt(d.price))
			)
			return total += (product.count * product.price) + addons_cost
		});
		return { count: products.length, total }
	}

	//Redux Hooks
	const basket_establishment_id = useSelector((state: RootStateOrAny) => state.cart.establishment_id);
	const couponStore = useSelector((state: RootStateOrAny) => state.cart.coupon);
	const sub_total = useSelector((state: RootStateOrAny) => getAllProducts(state));
	const currency_symbol = useSelector((state: RootStateOrAny) => state.auth.currency_symbol);

	const dispatch = useDispatch();

	useIonViewWillEnter(() => {
		console.log(basket_establishment_id)
		if (basket_establishment_id === '' || basket_establishment_id === undefined)
			return

		axios.get(`/cart/${basket_establishment_id}?t=${new Date().getTime()}`)
			.then(res => {
				const data = res.data
				setData({
					details: data.establishment_details,
					charges: data.charges,
					address: data.address
				})
				setLoad(true);
			})
			.catch(err => {
				console.log(err)
			})
	}, [basket_establishment_id]);


	const couponSubmit = () => {

		if (coupon.code.trim() === '')
			return

		axios.post(`/coupon/verify`, { coupon_code: coupon.code })
			.then(res => {
				const data = res.data
				setCoupon({ ...coupon, request: true, returnData: res.data });
				if (data)
					dispatch(actions.coupon_add(res.data))
				else
					dispatch(actions.coupon_remove())
			})
			.catch(err => {
				console.log(err)
			})
	}

	return (
		<IonPage>
			<IonHeader className="bg-white ion-no-border border-bottom">
				<IonToolbar color="white">
					<IonButtons slot="start">
						<IonButton onClick={() => props.history.goBack()}>
							<IonIcon icon={arrowBackOutline} className="mr-2 align-text-top text-dark" />
						</IonButton>
					</IonButtons>
					<IonTitle className="p-0">
						<small className="font-weight-bold">{(data.details.name) ?? 'Cart'}</small>
					</IonTitle>
				</IonToolbar>
			</IonHeader>


			<IonContent fullscreen>
				{(basket_establishment_id === '' || basket_establishment_id === undefined || (sub_total.count === 0 && sub_total.total === 0)) ?
					(
						<Container fluid={true} className="h-100 d-flex align-items-center">
							<Col>
								<h4 className="font-weight-bold text-center">Seu carrinho está vazio</h4>
								<img src={require('../../assets/img/icons/common/pan-toss.png')} className="p-4 w-100" alt="pan" />
							</Col>
						</Container>
					)
					:
					( 
						<>
						{ load ? ( <Container>
							<Container fluid={true} className="my-3">
								<h6 className="font-weight-bold">Produtos no carrinho</h6>
								<Row className="my-2">
									<Col lg="5" className="pt-2 bg-white">
										<CartItems currency_symbol={currency_symbol} />
									</Col>
								</Row>
							</Container>

							<Container fluid={true} className="my-3 bg-white">
								<Row>
									<Col xs="2">
										<h3 className="m-0"> <IonIcon icon={cardOutline} className="text-muted mr-1 align-text-top" /> </h3>
									</Col>
									<Col>
										<Input placeholder="CÓDIGO DE CUPOM" onChange={(e) => setCoupon({ ...coupon, code: e.target.value })} defaultValue={couponStore && couponStore.coupon_code} className="border-0 shadow-0 p-0 font-weight-bold text-primary text-uppercase" type="text" />
									</Col>
									<Col xs="2">
										<Ripples className="p-0" onClick={couponSubmit}>
											<h3 className="m-0"> <IonIcon icon={chevronForward} className="text-muted mr-1 align-text-top" /> </h3>
										</Ripples>
									</Col>
								</Row>
								<Row>
									<Col className="ml-2">
										{(coupon.request || (couponStore && couponStore.coupon_code)) && (
											couponStore.id ? (
												<>
													<small className="text-success">Cupom aplicado com sucesso!</small>
													<small className="text-danger ml-3 font-weight-bold" onClick={() => { setCoupon({ ...coupon, code: '', request: false, returnData: false }); dispatch(actions.coupon_remove()) }}>REMOVER CUPOM</small>
												</>
											) :
												<small className="text-danger">Cupom inválido. Tente novamente!</small>
										)}
									</Col>
								</Row>
							</Container>

							<Container fluid={true} className="mt-3 mb-5 pb-8">
								<h6 className="font-weight-bold">DETALHES DA FATURA</h6>
								<Row>
									<Col lg="5" className="bg-white pt-2 px-0">
										{load && (
											<CartBillings coupon={couponStore} sub_total={sub_total.total} currency_symbol={currency_symbol} charges={data.charges} />
										)}
									</Col>
								</Row>
							</Container>

							<Container fluid={true} className="position-fixed fixed-bottom w-100 bg-white p-0 shadow-lg border-top">
								<Link to="/payment">
									<Button className="w-100 bg-success p-3 m-0 text-white">Prossiga para pagar</Button>
								</Link>
							</Container>
						</Container>) : [...Array(4)].map((e, i) => (<GeneralSkeletonText key={i} />))}
						</>
					)}
			</IonContent>


		</IonPage >
	);
};

export default Cart;
